import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    screen: 'calendar',
    darkMode: false,
    last: null,         // last screen for back button
    status: 'idle',
    error: null,
};

const screenSlice = createSlice({
    name: 'screen',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setScreen: (state, action) => {
            return {
              ...state,
              last: state.screen,      // set last screen as current screen before changin,
              screen: action.payload,
              status: 'succeeded',
              error: null,
            }
        },
        setScreenBack : (state) => {
            return {
              ...state,
              screen: state.last,
              status: 'succeeded',
              error: null,
            }
        },
        setScreenBack : (state) => {
            return {
              ...state,
              screen: state.last,
              status: 'succeeded',
              error: null,
            }
        },
        setDarkMode: (state, action) => {
            return {
              ...state,
              darkMode: action.payload,
            }
        }
    },
});

export const { reset, setScreen, setScreenBack, setDarkMode } = screenSlice.actions;
export const selectLock = state => state.screen;
export const selectScreen = state => state.screen.screen;
export const selectScreenStatus = state => state.screen.status;
export const selectLastScreen = state => state.screen.last;
export const selectDarkMode = state => state.screen.darkMode;

export default screenSlice.reducer;
